/**
 * Dr. Joe's Sign queue (Treatment Plan spec v1.4, S-23, SG-010). The
 * collaborating physician signs plans from every clinic whose nurse accounts
 * route to him, so his queue shows the clinic on each row.
 */

import { PageHeader } from '../components/ui';
import { SignQueue } from '../components/SignQueue';

export function SignQueuePage() {
  return (
    <div className="mx-auto max-w-[1240px]">
      <PageHeader title="Sign queue" subtitle="Plans from nurse accounts, waiting for your signature." />
      <SignQueue showClinic />
    </div>
  );
}
